import { NTab, NTabPane, NTabs } from 'naive-ui';
import { mapState, mapStores } from "pinia";
import { defineComponent } from "vue";

import BasePage from '../../core/base-page';

import { useStationStore } from "../../store/station.store";

import WidgetMap from '../../components/widget-map/widget-map.vue';

import { DispatchStoreSocketError, StoreError } from "~/exceptions/store.error";
import { LocationQuery } from 'vue-router';
import { useDispatchStore } from '~/store/dispatch.store';

import DispatchHeader from './dispatch-header/dispatch-header.vue';
import DispatchIndicators from './dispatch-indicators/dispatch-indicators.vue';
import DispatchDeviceTable from './dispatch-device-table/dispatch-device-table.vue';
import { DispatchDashboardFilterEnum } from '~/models/dispatch/dispatch-dasboard-filter.enum';

enum TabEnum {
    ALARMS = 'ALARMS',
    DEVICES = 'DEVICES',
    MAP = 'MAPS',
}

export default defineComponent({

    extends: BasePage,

    components: {
        DispatchHeader,
        DispatchIndicators,
        DispatchDeviceTable,

        WidgetMap,

        NTab,
        NTabs,
        NTabPane,
    },
    
    unmounted()  {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },

    data() {

        return  {
            
            resizeListener: null,
            width: window.innerWidth,

            currentTab: TabEnum.ALARMS,
            TabEnum,

            showIndicators: true,
            showMap: true,
            showDevices: true,
            showAlertCount: true,
        }
    },

    
    computed: {
        ...mapStores(useStationStore, useDispatchStore),
        ...mapState(useDispatchStore, ['since', 'before', 'stations']),
        ...mapState(useStationStore, ['groups', 'group' ]),
    },

    async mounted(): Promise<void> {

        const group: string = this.$route.params.group as string;
        const filter: DispatchDashboardFilterEnum = this.$route.query.filter as DispatchDashboardFilterEnum;

        try {

            await this.stationStore.init();

            if(!this.stationStore.groups?.length) {
                this.$router.push({name: 'wrong-configuration'});
                return;
            }

        } catch (error) {
            if(error instanceof StoreError ) {
                this.$router.push({ name: 'wrong-configuration' });
                return;
            } else {
                throw error;
            }
        }

        try {

            if(group === 'default') {
                this.$router.replace({name: 'dispatch', params: { group: this.stationStore.default.name}});
                return;
            }

            await this.stationStore.selectStationGroup(group);

            if(filter) {
                this.dispatchStore.setFilter(filter);
            }
            
            await this.dispatchStore.refresh();

        } catch (error) {
            if(error instanceof DispatchStoreSocketError) {
                console.error('Could initialize socket ',error);
            } else if(error instanceof StoreError ) {
                console.error('Could not load page',error);
                this.$router.push({ name: 'not-found' });
            } else {
                throw error;
            }
        }

        try {
            // this.dispatchStore.initSocket();
        } catch(error) {
            console.error(error);
        }

    },

    watch: {
        async $route(to: {query: LocationQuery, path: string}) {
            if(!to.path.includes('dispatch')){
                return;
            }

            let refresh: boolean = false;

            if(to?.query?.filter) {
                this.dispatchStore.setFilter(to?.query?.filter as DispatchDashboardFilterEnum);
                refresh = true;
            } else {
                this.dispatchStore.setFilter(DispatchDashboardFilterEnum.GAS);
            }
            
            if(this.stationStore.group?.name !== this.$route?.params.group) {
                await this.stationStore.selectStationGroup(this.$route?.params.group as string);
                await this.stationStore.refresh();
                this.dispatchStore.initSocket();
                refresh = true;
            }

            if(refresh) {
                this.dispatchStore.refresh();
            }
        },
    }
})